import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import profileReducer from '../features/profile/profileSlice';
import eventReducer from '../features/event/eventSlice';
import userReducer from '../features/user/userSlice';
import businessReducer from '../features/business/businessSlice';
import countriesReducer from '../features/countries/countriesSlice';
import isicrevfiveReducer from '../features/isicrevfive/isicrevfiveSlice';
import digitalCardsReducer from '../features/digitalcards/digitalCardsSlice';
import statisticsReducer from '../features/statistics/statisticsSlice';
import beetinqTeamReducer from '../features/beetinqteam/beetinqTeamSlice';



export const store = configureStore({
  reducer: {
    auth: authReducer,
    event: eventReducer,
    user: userReducer,
    profile: profileReducer,
    business: businessReducer,
    countries: countriesReducer,
    isicrevfive: isicrevfiveReducer,
    digitalCards: digitalCardsReducer,
    statistics: statisticsReducer,
    beetinqTeam: beetinqTeamReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: true
  })
});
